import React, { useMemo } from "react";
import { Container, Col, Row } from "reactstrap";
import { Fields } from "@repoflow/components/fields";
import { useSectionContext } from "@repoflow/components/section";
import { Link } from "react-router-dom";
import { Composed } from "components/preview/composed";
import * as widgets from "widgets/register";

import { previewPage } from "../edit/preview";

// Hoisted for the reason recorded in ../edit: a config literal is a new object
// every render and the provider rebuilds underneath it.
//
// What the section is FOR is below the fields, rendered. `html`, `style`,
// `script` and `frame` used to be here as four wide read-only blocks, which is
// the same content in the form nobody can read it in: a template is not its
// output, and four of them stacked said less about the section than one look at
// what they compose into. They are edited one click away, in the editor, beside
// a live version of that same picture.
//
// `types` and `values` were never here. They are JSON on the wire and their
// rendered form IS the Data tab of the editor — a read-only dump of the raw
// objects would be the only place in the app that shows somebody a serialised
// blob.
const VIEW_FIELDS = {
  "/Public/Section": {
    fields: ["sectionId", "tags"],
  },
};

export const Sidebar = () => null;

export const Indice = () => null;

// The section, what it renders as, and the two things you can do to it.
export const Content = ({
  match: {
    params: { siteId },
  },
}) => {
  const { values, schema, base } = useSectionContext();

  // The composer renders PAGES, and a section on its own is not one — it
  // previews as a page with exactly one code element in it, which is the same
  // adaptation the section editor's live pane makes. See ../edit/preview.
  //
  // Memoised on the row, so a render that changed nothing does not recompose.
  const page = useMemo(() => previewPage(values), [values]);

  return (
    <Container className="mt-4">
      <Row>
        <Col>
          <div className="float-right">
            <Link className="btn btn-primary" to={`${base}/edit`}>
              Edit
            </Link>{" "}
            <Link className="btn btn-danger" to={`${base}/remove`}>
              Remove
            </Link>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Fields
            schema={schema}
            values={values}
            widgets={widgets}
            target={{ $ref: "/Public/Section" }}
            config={VIEW_FIELDS}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          <h6 className="text-muted mb-3">Preview</h6>
          {/* Composed into the site's document shell, unlike the editor's live
              pane — this is the section as a page carrying it would serve it,
              which is the thing a read-only screen has to be honest about. */}
          <Composed siteId={siteId} page={page} height="60vh" />
        </Col>
      </Row>
    </Container>
  );
};
